import React from 'react';
import { Tag, Button, Space } from 'antd';
import { useAtom } from 'jotai';
import { breakdownFiltersAtom } from './atoms';

const ApiUsageBreakdownFilters = () => {
  const [filters, setFilters] = useAtom(breakdownFiltersAtom);

  if (filters.length === 0) return null;

  const removeFilter = (field: string, value: string) => {
    setFilters((prev) => prev.filter((f) => !(f.field === field && f.value === value)));
  };

  const clearAll = () => {
    setFilters([]);
  };

  return (
    <Space wrap style={{ marginBottom: 12 }}>
      {filters.map((f) => (
        <Tag
          key={`${f.field}-${f.value}`}
          closable
          onClose={() => removeFilter(f.field, f.value)}
          color="blue"
        >
          {f.display}
        </Tag>
      ))}
      <Button size="small" type="link" onClick={clearAll}>
        Clear All
      </Button>
    </Space>
  );
};

export default ApiUsageBreakdownFilters;
